import { useFieldContext } from "./form-contexts";
import { getFieldErrorId } from "./get-field-error-id";
import { mergeDescribedBy } from "./merge-described-by";

function useFieldDescribedBy(describedBy: string | undefined) {
  const field = useFieldContext<unknown>();

  return mergeDescribedBy(
    describedBy,
    field.state.meta.errors.length > 0 && getFieldErrorId(field.name)
  );
}

export { useFieldDescribedBy };
